import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { goToCheckout } from './checkout';
export function OfferSection() {
  return <section id="offer-section" className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-114">
      <div className="absolute inset-0 bg-radial-glow from-purple-900/20 via-zinc-950 to-zinc-950 pointer-events-none" data-id="element-115" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-116">
        <FadeIn className="glass-panel p-8 sm:p-12 rounded-3xl text-center border-purple-900/30 relative overflow-hidden" data-id="element-117">
          {/* Subtle top border gradient */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-chakra-gradient opacity-50" data-id="element-118" />

          <h2 className="text-3xl sm:text-4xl font-bold mb-6 text-white" data-id="element-119">
            Recupera el mando de tu vida por menos de lo que cuesta una cena.
          </h2>

          <p className="text-lg text-zinc-400 mb-10" data-id="element-120">
            Obtén el sistema completo "Chakra Reset: 7 Días de Desbloqueo" por
            un pago único.
          </p>

          <div className="mb-10" data-id="element-121">
            <div className="text-zinc-500 text-sm uppercase tracking-wider font-semibold mb-2" data-id="element-122">
              Oferta por tiempo limitado
            </div>
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-123">
              <span className="text-2xl text-zinc-500 line-through decoration-red-500/60 font-serif" data-id="element-124">
                $15.00
              </span>
              <span className="text-xs font-semibold uppercase tracking-wide bg-green-500/10 text-green-400 px-2.5 py-1 rounded-full border border-green-500/20" data-id="element-125">
                57% OFF
              </span>
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-126">
              <span className="text-5xl sm:text-6xl font-bold text-white tracking-tight" data-id="element-127">
                $6.39
              </span>
              <span className="text-zinc-500 self-end mb-2" data-id="element-128">USD</span>
            </div>
          </div>

          <Button size="lg" fullWidth className="text-lg sm:text-xl py-5 shadow-2xl shadow-purple-900/20" onClick={goToCheckout} data-id="element-129">
            ¡QUIERO DESBLOQUEAR MI PODER AHORA!
          </Button>

          <p className="text-sm text-zinc-500 mt-6" data-id="element-130">
            Acceso instantáneo. Empieza tu Día 1 en los próximos 2 minutos.
          </p>
        </FadeIn>
      </div>
    </section>;
}